<p>setup-shadow-loans works!</p>
